import React, { Component } from "react";
import Carousel from "nuka-carousel";

import Composition from "./Composition";
import Button from "../shared/Button";
import FolderTitle from "./FolderTitle";
import FolderToolbar from "./FolderToolbar";
import CompositionCreate from "./CompositionCreate";

const carouselInitialHeight = "480px";
const carouselSlideWidth = 200;
const carouselSlideWidthString = "200px";
const carouselEdgeEasing = "easePolyOut";

class Folder extends Component {
  componentDidMount() {
    setTimeout(() => window.dispatchEvent(new Event("resize")), 0);
  }

  renderCenterLeftControls({ previousSlide }) {
    return (
      <Button
        additionalClassName="folder__slider-left button--icon"
        icon="button__icon--arrow-left i-arrow-left-light"
        onClick={previousSlide}
      />
    );
  }

  renderCenterRightControls({ nextSlide }) {
    return (
      <Button
        additionalClassName="folder__slider-right button--icon"
        icon="button__icon--arrow-right i-arrow-right-light"
        onClick={nextSlide}
      />
    );
  }

  render() {
    const {
      id,
      title,
      models,
      handleDeleteModel,
      handleDeleteFolder,
      openDeleteModelConfirmationModal,
      openDownloadFolderModal,
      openShareModelModal,
      openUpdateFolderModal,
      userFullname,
      userCompany,
      clearModelExport
    } = this.props;

    const cellSpacing = 20;
    const slidesToScroll = this.sliderRef
      ? Math.floor(this.sliderRef.offsetWidth / carouselSlideWidth)
      : null;

    return (
      <div className="folder">
        <div className="folder__top">
          <FolderTitle
            id={id}
            title={title}
            openUpdateFolderModal={openUpdateFolderModal}
            handleDeleteFolder={() => handleDeleteFolder({ id })}
          />
          <FolderToolbar
            handleDeleteFolder={() => handleDeleteFolder({ id })}
          />
        </div>

        <div className="folder__slider" ref={ref => (this.sliderRef = ref)}>
          {models.length ? (
            <Carousel
              edgeEasing={carouselEdgeEasing}
              intialHeight={carouselInitialHeight}
              cellSpacing={cellSpacing}
              slidesToScroll={slidesToScroll}
              slideWidth={carouselSlideWidthString}
              renderBottomCenterControls={null}
              renderCenterLeftControls={this.renderCenterLeftControls}
              renderCenterRightControls={this.renderCenterRightControls}
            >
              {models.map(model => (
                <Composition
                  lng={this.props.lng}
                  key={`f-${model.id}`}
                  folderTitle={title}
                  userFullname={userFullname}
                  userCompany={userCompany}
                  clearModelExport={clearModelExport}
                  openDownloadFolderModal={openDownloadFolderModal}
                  openDeleteModelConfirmationModal={
                    openDeleteModelConfirmationModal
                  }
                  openShareModelModal={openShareModelModal}
                  handleDeleteModel={handleDeleteModel}
                  {...model}
                />
              ))}
              <CompositionCreate />
            </Carousel>
          ) : (
            <CompositionCreate />
          )}
        </div>
      </div>
    );
  }
}

export default Folder;



// WEBPACK FOOTER //
// ./src/components/account/Folder.js